import { batch } from 'react-redux';
import { Dispatch } from 'redux';

import { AUTH_STATE_NAME } from '../../../../auth';
import { APP_CONFIG } from '../../../../config';
import { selectTrySigninUrl } from '../../../../configuration';
import { clearFetchData } from '../../../../middleware';
import {
    fetchGetSignOutRequest, SESSION_LOGOUT
} from '../../../../session';
import { getItem } from '../../../../storage/use-session-storage/session-storage-helpers';
import { SessionStorageKeys } from '../../../../storage/use-session-storage/session-storage.constants';
import { USER_PROFILES_STATE_NAME } from '../../../../user-profiles';
import { AppState } from '../../../app.types';
import { clearApp } from '../../app.actions';
import { checkIsOneRosterActivatedSchool } from '../../app.selectors';
import { EffectOptions } from '../app-effects-middleware.types';

const logoutActionReg = new RegExp(SESSION_LOGOUT);

export function logoutEffects ({
    action,
    dispatch,
    getState
}: EffectOptions) {
    if (!logoutActionReg.test(action.type)) {
        return;
    }

    if (checkIsOneRosterActivatedSchool(getState())) {
        handleLogoutRedirect({
            state: getState(),
            dispatch
        });
    } else {
        const signOutRequest: Promise<void> = dispatch(fetchGetSignOutRequest()) as any;

        signOutRequest.finally(() => {
            handleLogoutRedirect({
                state: getState(),
                dispatch
            });
        });
    }
}

type LogoutOptions = {
    state: AppState
    dispatch: Dispatch
};

export function handleLogoutRedirect ({
    state, dispatch
}: LogoutOptions) {
    const signInUrl = getLogoutSignInUrl(state);

    handleClearSessionState({ dispatch });

    console.debug('handleLogoutRedirect() to signInUrl', signInUrl);

    // When running in development just refresh for sign in url
    if (APP_CONFIG.isRunningOnDevelopersMachine) {
        window.location.reload();
    } else if (signInUrl === null) {
        console.error('Unable to find LoginURL from configuration');
    } else {
        location.href = signInUrl;
    }
}

type ClearSessionOptions = {
    dispatch: Dispatch
};

export function handleClearSessionState ({ dispatch }: ClearSessionOptions) {
    batch(() => {
        dispatch(clearFetchData(AUTH_STATE_NAME));
        dispatch(clearFetchData(USER_PROFILES_STATE_NAME));
        dispatch(clearApp());
    });
}

function getLogoutSignInUrl (state: AppState): string {
    const mathleticsSignInUrl = selectTrySigninUrl(state);

    if (!checkIsOneRosterActivatedSchool(state)) return mathleticsSignInUrl;

    const threeEssentialsSignInUrl = getItem({ key: SessionStorageKeys.logout_return_to });

    if (threeEssentialsSignInUrl) return threeEssentialsSignInUrl;

    return mathleticsSignInUrl;
}
